module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "model": "owners",
      "entity": _vm.model,
      "fields": _vm.ownerFields,
      "after-submit": _vm.afterSubmit,
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-017dff97!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup-guide/OwnerForm.vue
// module id = 964
// module chunks = 2